import script from "./PaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__